// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 🎨 Design System - Comprehensive Color Foundation */

@layer base {
  :root {
    /* ===== CORE FOUNDATION ===== */
    --color-background: 0 0% 100%;
    --color-foreground: 222.2 84% 4.9%;
    --color-surface: 0 0% 100%;
    --color-surface-foreground: 222.2 84% 4.9%;
    
    /* ===== INTERACTIVE STATES ===== */
    --color-primary: 221.2 83.2% 53.3%;
    --color-primary-foreground: 210 40% 98%;
    --color-primary-hover: 221.2 83.2% 48%;
    --color-primary-muted: 221.2 83.2% 95%;
    
    --color-secondary: 210 40% 96%;
    --color-secondary-foreground: 222.2 84% 4.9%;
    --color-secondary-hover: 210 40% 90%;
    
    /* ===== STATUS COLORS ===== */
    --color-success: 142.1 76.2% 36.3%;
    --color-success-foreground: 355.7 100% 97.3%;
    --color-success-hover: 142.1 76.2% 31%;
    --color-success-muted: 142.1 76.2% 95%;
    
    --color-warning: 32.5 94.6% 56.9%;
    --color-warning-foreground: 222.2 84% 4.9%;
    --color-warning-hover: 32.5 94.6% 51%;
    --color-warning-muted: 32.5 94.6% 95%;
    
    --color-error: 0 84.2% 60.2%;
    --color-error-foreground: 210 40% 98%;
    --color-error-hover: 0 84.2% 55%;
    --color-error-muted: 0 84.2% 95%;
    
    --color-info: 221.2 83.2% 53.3%;
    --color-info-foreground: 210 40% 98%;
    --color-info-hover: 221.2 83.2% 48%;
    --color-info-muted: 221.2 83.2% 95%;
    
    /* ===== NEUTRAL PALETTE ===== */
    --color-muted: 210 40% 96%;
    --color-muted-foreground: 215.4 16.3% 46.9%;
    --color-muted-hover: 210 40% 90%;
    
    --color-accent: 210 40% 96%;
    --color-accent-foreground: 222.2 84% 4.9%;
    --color-accent-hover: 210 40% 90%;
    
    --color-border: 214.3 31.8% 91.4%;
    --color-border-muted: 214.3 31.8% 95%;
    --color-input: 214.3 31.8% 91.4%;
    --color-ring: 221.2 83.2% 53.3%;
    
    /* ===== SPECIAL PURPOSE ===== */
    --color-destructive: 0 84.2% 60.2%;
    --color-destructive-foreground: 210 40% 98%;
    
    --color-popover: 0 0% 100%;
    --color-popover-foreground: 222.2 84% 4.9%;
    
    --color-card: 0 0% 100%;
    --color-card-foreground: 222.2 84% 4.9%;
    
    /* ===== NAVIGATION & LAYOUT ===== */
    --color-header: 0 0% 100%;
    --color-header-foreground: 222.2 84% 4.9%;
    --color-header-border: 214.3 31.8% 91.4%;
    
    --color-tab-bar: 210 40% 98%;
    --color-tab-bar-foreground: 222.2 84% 4.9%;
    --color-tab-bar-border: 214.3 31.8% 91.4%;
    --color-tab-bar-active: 221.2 83.2% 53.3%;
    
    --color-sidebar: 0 0% 100%;
    --color-sidebar-foreground: 222.2 84% 4.9%;
    
    /* ===== GRADIENTS & SPECIAL EFFECTS ===== */
    --gradient-primary: linear-gradient(135deg, hsl(var(--color-primary)) 0%, hsl(262.1 83.3% 57.8%) 100%);
    --gradient-success: linear-gradient(135deg, hsl(var(--color-success)) 0%, hsl(173.4 82.3% 50%) 100%);
    --gradient-warning: linear-gradient(135deg, hsl(var(--color-warning)) 0%, hsl(20.5 90.2% 48.2%) 100%);
    --gradient-rainbow: linear-gradient(-45deg, 
      hsl(var(--color-primary)), 
      hsl(262.1 83.3% 57.8%), 
      hsl(316.7 77.8% 59.6%), 
      hsl(188.7 85.7% 53.3%)
    );
    
    /* ===== OPACITY LEVELS ===== */
    --opacity-disabled: 0.5;
    --opacity-muted: 0.7;
    --opacity-hover: 0.8;
    --opacity-press: 0.9;
    
    /* ===== SHADOWS ===== */
    --shadow-color: 220 3% 15%;
    --shadow-sm: 0 1px 2px 0 hsl(var(--shadow-color) / 0.05);
    --shadow-base: 0 1px 3px 0 hsl(var(--shadow-color) / 0.1), 0 1px 2px -1px hsl(var(--shadow-color) / 0.1);
    --shadow-md: 0 4px 6px -1px hsl(var(--shadow-color) / 0.1), 0 2px 4px -2px hsl(var(--shadow-color) / 0.1);
    --shadow-lg: 0 10px 15px -3px hsl(var(--shadow-color) / 0.1), 0 4px 6px -4px hsl(var(--shadow-color) / 0.1);
    --shadow-xl: 0 20px 25px -5px hsl(var(--shadow-color) / 0.1), 0 8px 10px -6px hsl(var(--shadow-color) / 0.1);
    
    /* ===== SCROLLBAR STYLING ===== */
    --scrollbar-track: hsl(var(--color-muted));
    --scrollbar-thumb: hsl(var(--color-muted-foreground) / 0.3);
    --scrollbar-thumb-hover: hsl(var(--color-muted-foreground) / 0.5);
    
    /* ===== MISC ===== */
    --radius: 0.75rem;
  }

  .dark {
    /* ===== CORE FOUNDATION ===== */
    --color-background: 222.2 84% 4.9%;
    --color-foreground: 210 40% 98%;
    --color-surface: 222.2 84% 4.9%;
    --color-surface-foreground: 210 40% 98%;
    
    /* ===== INTERACTIVE STATES ===== */
    --color-primary: 217.2 91.2% 59.8%;
    --color-primary-foreground: 222.2 84% 4.9%;
    --color-primary-hover: 217.2 91.2% 54%;
    --color-primary-muted: 217.2 32.6% 17.5%;
    
    --color-secondary: 217.2 32.6% 17.5%;
    --color-secondary-foreground: 210 40% 98%;
    --color-secondary-hover: 217.2 32.6% 22%;
    
    /* ===== STATUS COLORS ===== */
    --color-success: 142.1 70.6% 45.3%;
    --color-success-foreground: 144.9 80.4% 10%;
    --color-success-hover: 142.1 70.6% 40%;
    --color-success-muted: 142.1 70.6% 8%;
    
    --color-warning: 35.5 91.7% 48.2%;
    --color-warning-foreground: 20.5 90.2% 4.3%;
    --color-warning-hover: 35.5 91.7% 43%;
    --color-warning-muted: 35.5 91.7% 8%;
    
    --color-error: 0 72.2% 50.6%;
    --color-error-foreground: 210 40% 98%;
    --color-error-hover: 0 72.2% 45%;
    --color-error-muted: 0 72.2% 8%;
    
    --color-info: 217.2 91.2% 59.8%;
    --color-info-foreground: 222.2 84% 4.9%;
    --color-info-hover: 217.2 91.2% 54%;
    --color-info-muted: 217.2 32.6% 17.5%;
    
    /* ===== NEUTRAL PALETTE ===== */
    --color-muted: 217.2 32.6% 17.5%;
    --color-muted-foreground: 215 20.2% 65.1%;
    --color-muted-hover: 217.2 32.6% 22%;
    
    --color-accent: 217.2 32.6% 17.5%;
    --color-accent-foreground: 210 40% 98%;
    --color-accent-hover: 217.2 32.6% 22%;
    
    --color-border: 217.2 32.6% 17.5%;
    --color-border-muted: 217.2 32.6% 12%;
    --color-input: 217.2 32.6% 17.5%;
    --color-ring: 224.3 76.3% 94.1%;
    
    /* ===== SPECIAL PURPOSE ===== */
    --color-destructive: 0 62.8% 30.6%;
    --color-destructive-foreground: 210 40% 98%;
    
    --color-popover: 222.2 84% 4.9%;
    --color-popover-foreground: 210 40% 98%;
    
    --color-card: 222.2 84% 4.9%;
    --color-card-foreground: 210 40% 98%;
    
    /* ===== NAVIGATION & LAYOUT ===== */
    --color-header: 217.2 32.6% 15%;
    --color-header-foreground: 210 40% 98%;
    --color-header-border: 217.2 32.6% 20%;
    
    --color-tab-bar: 217.2 32.6% 12%;
    --color-tab-bar-foreground: 210 40% 98%;
    --color-tab-bar-border: 217.2 32.6% 17.5%;
    --color-tab-bar-active: 217.2 91.2% 59.8%;
    
    --color-sidebar: 222.2 84% 4.9%;
    --color-sidebar-foreground: 210 40% 98%;
    
    /* ===== SHADOWS ===== */
    --shadow-color: 220 3% 2%;
    
    /* ===== SCROLLBAR STYLING ===== */
    --scrollbar-track: hsl(var(--color-muted));
    --scrollbar-thumb: hsl(var(--color-muted-foreground) / 0.3);
    --scrollbar-thumb-hover: hsl(var(--color-muted-foreground) / 0.5);
  }
}

/* ===== GLOBAL SCROLLBAR STYLING ===== */
* {
  scrollbar-width: thin;
  scrollbar-color: var(--scrollbar-thumb) var(--scrollbar-track);
}

*::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

*::-webkit-scrollbar-track {
  background: var(--scrollbar-track);
  border-radius: 4px;
}

*::-webkit-scrollbar-thumb {
  background: var(--scrollbar-thumb);
  border-radius: 4px;
  transition: background-color 0.2s ease;
}

*::-webkit-scrollbar-thumb:hover {
  background: var(--scrollbar-thumb-hover);
}

*::-webkit-scrollbar-corner {
  background: var(--scrollbar-track);
}

/* ===== UTILITY CLASSES ===== */
.text-success {
  color: hsl(var(--color-success));
}

.text-warning {
  color: hsl(var(--color-warning));
}

.text-error {
  color: hsl(var(--color-error));
}

.text-info {
  color: hsl(var(--color-info));
}

.bg-success-muted {
  background-color: hsl(var(--color-success-muted));
}

.bg-warning-muted {
  background-color: hsl(var(--color-warning-muted));
}

.bg-error-muted {
  background-color: hsl(var(--color-error-muted));
}

.bg-info-muted {
  background-color: hsl(var(--color-info-muted));
}

.gradient-primary {
  background: var(--gradient-primary);
}

.gradient-success {
  background: var(--gradient-success);
}

.gradient-warning {
  background: var(--gradient-warning);
}

.gradient-rainbow {
  background: var(--gradient-rainbow);
  background-size: 400% 400%;
  animation: gradient-flow 8s ease infinite;
}

@keyframes gradient-flow {
  0%, 100% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
}
`, "",{"version":3,"sources":["webpack://./src/styles/design-system.css"],"names":[],"mappings":"AAAA,sDAAsD;;AAEtD;EACE;IACE,gCAAgC;IAChC,6BAA6B;IAC7B,kCAAkC;IAClC,0BAA0B;IAC1B,0CAA0C;;IAE1C,mCAAmC;IACnC,kCAAkC;IAClC,uCAAuC;IACvC,sCAAsC;IACtC,sCAAsC;;IAEtC,8BAA8B;IAC9B,4CAA4C;IAC5C,oCAAoC;;IAEpC,8BAA8B;IAC9B,kCAAkC;IAClC,4CAA4C;IAC5C,sCAAsC;IACtC,sCAAsC;;IAEtC,iCAAiC;IACjC,0CAA0C;IAC1C,qCAAqC;IACrC,qCAAqC;;IAErC,4BAA4B;IAC5B,qCAAqC;IACrC,gCAAgC;IAChC,gCAAgC;;IAEhC,+BAA+B;IAC/B,oCAAoC;IACpC,mCAAmC;IACnC,mCAAmC;;IAEnC,gCAAgC;IAChC,0BAA0B;IAC1B,2CAA2C;IAC3C,gCAAgC;;IAEhC,2BAA2B;IAC3B,yCAAyC;IACzC,iCAAiC;;IAEjC,iCAAiC;IACjC,qCAAqC;IACrC,gCAAgC;IAChC,+BAA+B;;IAE/B,gCAAgC;IAChC,kCAAkC;IAClC,2CAA2C;;IAE3C,0BAA0B;IAC1B,0CAA0C;;IAE1C,uBAAuB;IACvB,uCAAuC;;IAEvC,oCAAoC;IACpC,yBAAyB;IACzB,yCAAyC;IACzC,wCAAwC;;IAExC,4BAA4B;IAC5B,0CAA0C;IAC1C,yCAAyC;IACzC,yCAAyC;;IAEzC,0BAA0B;IAC1B,0CAA0C;;IAE1C,4CAA4C;IAC5C,sGAAsG;IACtG,oGAAoG;IACpG,qGAAqG;IACrG;;;;;KAKC;;IAED,+BAA+B;IAC/B,uBAAuB;IACvB,oBAAoB;IACpB,oBAAoB;IACpB,oBAAoB;;IAEpB,wBAAwB;IACxB,0BAA0B;IAC1B,wDAAwD;IACxD,wGAAwG;IACxG,yGAAyG;IACzG,2GAA2G;IAC3G,4GAA4G;;IAE5G,kCAAkC;IAClC,0CAA0C;IAC1C,2DAA2D;IAC3D,iEAAiE;;IAEjE,qBAAqB;IACrB,iBAAiB;EACnB;;EAEA;IACE,gCAAgC;IAChC,kCAAkC;IAClC,+BAA+B;IAC/B,+BAA+B;IAC/B,uCAAuC;;IAEvC,mCAAmC;IACnC,kCAAkC;IAClC,0CAA0C;IAC1C,sCAAsC;IACtC,wCAAwC;;IAExC,oCAAoC;IACpC,yCAAyC;IACzC,wCAAwC;;IAExC,8BAA8B;IAC9B,kCAAkC;IAClC,2CAA2C;IAC3C,sCAAsC;IACtC,qCAAqC;;IAErC,iCAAiC;IACjC,2CAA2C;IAC3C,qCAAqC;IACrC,oCAAoC;;IAEpC,4BAA4B;IAC5B,qCAAqC;IACrC,gCAAgC;IAChC,+BAA+B;;IAE/B,+BAA+B;IAC/B,uCAAuC;IACvC,mCAAmC;IACnC,qCAAqC;;IAErC,gCAAgC;IAChC,gCAAgC;IAChC,yCAAyC;IACzC,oCAAoC;;IAEpC,iCAAiC;IACjC,sCAAsC;IACtC,qCAAqC;;IAErC,iCAAiC;IACjC,qCAAqC;IACrC,gCAAgC;IAChC,+BAA+B;;IAE/B,gCAAgC;IAChC,kCAAkC;IAClC,2CAA2C;;IAE3C,+BAA+B;IAC/B,uCAAuC;;IAEvC,4BAA4B;IAC5B,oCAAoC;;IAEpC,oCAAoC;IACpC,+BAA+B;IAC/B,sCAAsC;IACtC,sCAAsC;;IAEtC,gCAAgC;IAChC,uCAAuC;IACvC,yCAAyC;IACzC,yCAAyC;;IAEzC,+BAA+B;IAC/B,uCAAuC;;IAEvC,wBAAwB;IACxB,yBAAyB;;IAEzB,kCAAkC;IAClC,0CAA0C;IAC1C,2DAA2D;IAC3D,iEAAiE;EACnE;AACF;;AAEA,yCAAyC;AACzC;EACE,qBAAqB;EACrB,8DAA8D;AAChE;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,kCAAkC;AACpC;;AAEA,gCAAgC;AAChC;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;EACnC,0BAA0B;EAC1B,yCAAyC;AAC3C;;AAEA;EACE,WAAW,2BAA2B,EAAE;EACxC,MAAM,6BAA6B,EAAE;AACvC","sourcesContent":["/* 🎨 Design System - Comprehensive Color Foundation */\n\n@layer base {\n  :root {\n    /* ===== CORE FOUNDATION ===== */\n    --color-background: 0 0% 100%;\n    --color-foreground: 222.2 84% 4.9%;\n    --color-surface: 0 0% 100%;\n    --color-surface-foreground: 222.2 84% 4.9%;\n    \n    /* ===== INTERACTIVE STATES ===== */\n    --color-primary: 221.2 83.2% 53.3%;\n    --color-primary-foreground: 210 40% 98%;\n    --color-primary-hover: 221.2 83.2% 48%;\n    --color-primary-muted: 221.2 83.2% 95%;\n    \n    --color-secondary: 210 40% 96%;\n    --color-secondary-foreground: 222.2 84% 4.9%;\n    --color-secondary-hover: 210 40% 90%;\n    \n    /* ===== STATUS COLORS ===== */\n    --color-success: 142.1 76.2% 36.3%;\n    --color-success-foreground: 355.7 100% 97.3%;\n    --color-success-hover: 142.1 76.2% 31%;\n    --color-success-muted: 142.1 76.2% 95%;\n    \n    --color-warning: 32.5 94.6% 56.9%;\n    --color-warning-foreground: 222.2 84% 4.9%;\n    --color-warning-hover: 32.5 94.6% 51%;\n    --color-warning-muted: 32.5 94.6% 95%;\n    \n    --color-error: 0 84.2% 60.2%;\n    --color-error-foreground: 210 40% 98%;\n    --color-error-hover: 0 84.2% 55%;\n    --color-error-muted: 0 84.2% 95%;\n    \n    --color-info: 221.2 83.2% 53.3%;\n    --color-info-foreground: 210 40% 98%;\n    --color-info-hover: 221.2 83.2% 48%;\n    --color-info-muted: 221.2 83.2% 95%;\n    \n    /* ===== NEUTRAL PALETTE ===== */\n    --color-muted: 210 40% 96%;\n    --color-muted-foreground: 215.4 16.3% 46.9%;\n    --color-muted-hover: 210 40% 90%;\n    \n    --color-accent: 210 40% 96%;\n    --color-accent-foreground: 222.2 84% 4.9%;\n    --color-accent-hover: 210 40% 90%;\n    \n    --color-border: 214.3 31.8% 91.4%;\n    --color-border-muted: 214.3 31.8% 95%;\n    --color-input: 214.3 31.8% 91.4%;\n    --color-ring: 221.2 83.2% 53.3%;\n    \n    /* ===== SPECIAL PURPOSE ===== */\n    --color-destructive: 0 84.2% 60.2%;\n    --color-destructive-foreground: 210 40% 98%;\n    \n    --color-popover: 0 0% 100%;\n    --color-popover-foreground: 222.2 84% 4.9%;\n    \n    --color-card: 0 0% 100%;\n    --color-card-foreground: 222.2 84% 4.9%;\n    \n    /* ===== NAVIGATION & LAYOUT ===== */\n    --color-header: 0 0% 100%;\n    --color-header-foreground: 222.2 84% 4.9%;\n    --color-header-border: 214.3 31.8% 91.4%;\n    \n    --color-tab-bar: 210 40% 98%;\n    --color-tab-bar-foreground: 222.2 84% 4.9%;\n    --color-tab-bar-border: 214.3 31.8% 91.4%;\n    --color-tab-bar-active: 221.2 83.2% 53.3%;\n    \n    --color-sidebar: 0 0% 100%;\n    --color-sidebar-foreground: 222.2 84% 4.9%;\n    \n    /* ===== GRADIENTS & SPECIAL EFFECTS ===== */\n    --gradient-primary: linear-gradient(135deg, hsl(var(--color-primary)) 0%, hsl(262.1 83.3% 57.8%) 100%);\n    --gradient-success: linear-gradient(135deg, hsl(var(--color-success)) 0%, hsl(173.4 82.3% 50%) 100%);\n    --gradient-warning: linear-gradient(135deg, hsl(var(--color-warning)) 0%, hsl(20.5 90.2% 48.2%) 100%);\n    --gradient-rainbow: linear-gradient(-45deg, \n      hsl(var(--color-primary)), \n      hsl(262.1 83.3% 57.8%), \n      hsl(316.7 77.8% 59.6%), \n      hsl(188.7 85.7% 53.3%)\n    );\n    \n    /* ===== OPACITY LEVELS ===== */\n    --opacity-disabled: 0.5;\n    --opacity-muted: 0.7;\n    --opacity-hover: 0.8;\n    --opacity-press: 0.9;\n    \n    /* ===== SHADOWS ===== */\n    --shadow-color: 220 3% 15%;\n    --shadow-sm: 0 1px 2px 0 hsl(var(--shadow-color) / 0.05);\n    --shadow-base: 0 1px 3px 0 hsl(var(--shadow-color) / 0.1), 0 1px 2px -1px hsl(var(--shadow-color) / 0.1);\n    --shadow-md: 0 4px 6px -1px hsl(var(--shadow-color) / 0.1), 0 2px 4px -2px hsl(var(--shadow-color) / 0.1);\n    --shadow-lg: 0 10px 15px -3px hsl(var(--shadow-color) / 0.1), 0 4px 6px -4px hsl(var(--shadow-color) / 0.1);\n    --shadow-xl: 0 20px 25px -5px hsl(var(--shadow-color) / 0.1), 0 8px 10px -6px hsl(var(--shadow-color) / 0.1);\n    \n    /* ===== SCROLLBAR STYLING ===== */\n    --scrollbar-track: hsl(var(--color-muted));\n    --scrollbar-thumb: hsl(var(--color-muted-foreground) / 0.3);\n    --scrollbar-thumb-hover: hsl(var(--color-muted-foreground) / 0.5);\n    \n    /* ===== MISC ===== */\n    --radius: 0.75rem;\n  }\n\n  .dark {\n    /* ===== CORE FOUNDATION ===== */\n    --color-background: 222.2 84% 4.9%;\n    --color-foreground: 210 40% 98%;\n    --color-surface: 222.2 84% 4.9%;\n    --color-surface-foreground: 210 40% 98%;\n    \n    /* ===== INTERACTIVE STATES ===== */\n    --color-primary: 217.2 91.2% 59.8%;\n    --color-primary-foreground: 222.2 84% 4.9%;\n    --color-primary-hover: 217.2 91.2% 54%;\n    --color-primary-muted: 217.2 32.6% 17.5%;\n    \n    --color-secondary: 217.2 32.6% 17.5%;\n    --color-secondary-foreground: 210 40% 98%;\n    --color-secondary-hover: 217.2 32.6% 22%;\n    \n    /* ===== STATUS COLORS ===== */\n    --color-success: 142.1 70.6% 45.3%;\n    --color-success-foreground: 144.9 80.4% 10%;\n    --color-success-hover: 142.1 70.6% 40%;\n    --color-success-muted: 142.1 70.6% 8%;\n    \n    --color-warning: 35.5 91.7% 48.2%;\n    --color-warning-foreground: 20.5 90.2% 4.3%;\n    --color-warning-hover: 35.5 91.7% 43%;\n    --color-warning-muted: 35.5 91.7% 8%;\n    \n    --color-error: 0 72.2% 50.6%;\n    --color-error-foreground: 210 40% 98%;\n    --color-error-hover: 0 72.2% 45%;\n    --color-error-muted: 0 72.2% 8%;\n    \n    --color-info: 217.2 91.2% 59.8%;\n    --color-info-foreground: 222.2 84% 4.9%;\n    --color-info-hover: 217.2 91.2% 54%;\n    --color-info-muted: 217.2 32.6% 17.5%;\n    \n    /* ===== NEUTRAL PALETTE ===== */\n    --color-muted: 217.2 32.6% 17.5%;\n    --color-muted-foreground: 215 20.2% 65.1%;\n    --color-muted-hover: 217.2 32.6% 22%;\n    \n    --color-accent: 217.2 32.6% 17.5%;\n    --color-accent-foreground: 210 40% 98%;\n    --color-accent-hover: 217.2 32.6% 22%;\n    \n    --color-border: 217.2 32.6% 17.5%;\n    --color-border-muted: 217.2 32.6% 12%;\n    --color-input: 217.2 32.6% 17.5%;\n    --color-ring: 224.3 76.3% 94.1%;\n    \n    /* ===== SPECIAL PURPOSE ===== */\n    --color-destructive: 0 62.8% 30.6%;\n    --color-destructive-foreground: 210 40% 98%;\n    \n    --color-popover: 222.2 84% 4.9%;\n    --color-popover-foreground: 210 40% 98%;\n    \n    --color-card: 222.2 84% 4.9%;\n    --color-card-foreground: 210 40% 98%;\n    \n    /* ===== NAVIGATION & LAYOUT ===== */\n    --color-header: 217.2 32.6% 15%;\n    --color-header-foreground: 210 40% 98%;\n    --color-header-border: 217.2 32.6% 20%;\n    \n    --color-tab-bar: 217.2 32.6% 12%;\n    --color-tab-bar-foreground: 210 40% 98%;\n    --color-tab-bar-border: 217.2 32.6% 17.5%;\n    --color-tab-bar-active: 217.2 91.2% 59.8%;\n    \n    --color-sidebar: 222.2 84% 4.9%;\n    --color-sidebar-foreground: 210 40% 98%;\n    \n    /* ===== SHADOWS ===== */\n    --shadow-color: 220 3% 2%;\n    \n    /* ===== SCROLLBAR STYLING ===== */\n    --scrollbar-track: hsl(var(--color-muted));\n    --scrollbar-thumb: hsl(var(--color-muted-foreground) / 0.3);\n    --scrollbar-thumb-hover: hsl(var(--color-muted-foreground) / 0.5);\n  }\n}\n\n/* ===== GLOBAL SCROLLBAR STYLING ===== */\n* {\n  scrollbar-width: thin;\n  scrollbar-color: var(--scrollbar-thumb) var(--scrollbar-track);\n}\n\n*::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\n*::-webkit-scrollbar-track {\n  background: var(--scrollbar-track);\n  border-radius: 4px;\n}\n\n*::-webkit-scrollbar-thumb {\n  background: var(--scrollbar-thumb);\n  border-radius: 4px;\n  transition: background-color 0.2s ease;\n}\n\n*::-webkit-scrollbar-thumb:hover {\n  background: var(--scrollbar-thumb-hover);\n}\n\n*::-webkit-scrollbar-corner {\n  background: var(--scrollbar-track);\n}\n\n/* ===== UTILITY CLASSES ===== */\n.text-success {\n  color: hsl(var(--color-success));\n}\n\n.text-warning {\n  color: hsl(var(--color-warning));\n}\n\n.text-error {\n  color: hsl(var(--color-error));\n}\n\n.text-info {\n  color: hsl(var(--color-info));\n}\n\n.bg-success-muted {\n  background-color: hsl(var(--color-success-muted));\n}\n\n.bg-warning-muted {\n  background-color: hsl(var(--color-warning-muted));\n}\n\n.bg-error-muted {\n  background-color: hsl(var(--color-error-muted));\n}\n\n.bg-info-muted {\n  background-color: hsl(var(--color-info-muted));\n}\n\n.gradient-primary {\n  background: var(--gradient-primary);\n}\n\n.gradient-success {\n  background: var(--gradient-success);\n}\n\n.gradient-warning {\n  background: var(--gradient-warning);\n}\n\n.gradient-rainbow {\n  background: var(--gradient-rainbow);\n  background-size: 400% 400%;\n  animation: gradient-flow 8s ease infinite;\n}\n\n@keyframes gradient-flow {\n  0%, 100% { background-position: 0% 50%; }\n  50% { background-position: 100% 50%; }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
